import { useIntl } from "react-intl";
import { IconLock, IconWorld } from "@tabler/icons-react";
import { Badge } from "@mantine/core";

export const ScopeBadge = ({ scope }: { scope: "public" | "private" }) => {
  const intl = useIntl();
  const isPrivate = scope === "private";
  const scopeMessage = (
    isPrivate ?
        intl.formatMessage({
          defaultMessage: "Private",
          id: "label.private",
        }) :
        intl.formatMessage({
          defaultMessage: "Public",
          id: "label.public",
        })
  );

  return (
    <Badge
      fw={400}
      size="lg"
      variant="outline"
      color={isPrivate ? "purpleBlue" : "success"}
      leftSection={isPrivate ?
          <IconLock size={14} /> :
          <IconWorld size={14} />}
    >
      {scopeMessage}
    </Badge>
  );
};
